import React, { MouseEvent } from 'react';
import { MdLens } from '@react-icons/all-files/md/MdLens';

import { useEditor } from '../../hooks';
import Portal from '../Portal';
import Tooltip from '../Tooltip';
import * as S from './Toolbar.style';

interface Props {
  tools: string[];
  onSelect: (type: string) => void;
}

export default function Toolbar({ tools, onSelect }: Props) {
  const { components } = useEditor();

  function handleClick(type: string) {
    return (e: MouseEvent) => {
      e.stopPropagation();
      onSelect(type);
    };
  }

  return (
    <Portal containerSelector="#canvas">
      <S.Container>
        { tools.map((type) => (
          <Tooltip key={type} message={components[type].label || type}>
            <S.Button onClick={handleClick(type)} type="button">
              { components[type].renderIcon?.({}) || <MdLens /> }
            </S.Button>
          </Tooltip>
        )) }
      </S.Container>
    </Portal>
  );
}
